import React, {useEffect, useState} from "react";

export default function DecoderDbIndex() {

    const [dataJson, setDataJson] = useState(null)
    useEffect(() => {
        //fetchIndex()
    }, []);



    function fetchIndex() {

        console.log("FETCH INDEX")

        //const name = "Firmware_145_31.57.decdb"
        //const name = "Firmware_151_5.3_DCC.decdb"

        const url = "https://www.decoderdb.de/?listAll"

        fetch(url)
            .then(response => response.text())
            .then(text => console.log(text))
            //.then(text => readXML(text))

    }

}
